export default __webpack_public_path__ + "static/media/OMSC_08.a57c572c.gif";